<template>
  <v-card
    flat
  >
    <div
      class="mt-5"
    >
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="updateSettings"
        >
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="formData.weekly_point"
                outlined
                dense
                label="Weekly Point *"
                hide-details="auto"
                class="mb-6"
                :rules="[validators.required, validators.integerValidator]"
                :error-messages="errors.weekly_point"
                @change="errors.weekly_point = []"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-btn
                color="primary"
                class="me-3"
                type="submit"
                :loading="isLoading"
              >
                Save
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                type="reset"
                @click.prevent="loadSettings"
              >
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import { required, integerValidator } from '@core/utils/validation'

export default {
	name: 'WeeklyPoint',
	data() {
		return {
			formData: { weekly_point: 5000 },
			valid: true,
			errors: {},
			validators: { required, integerValidator },
			isLoading: false,
		}
	},
	mounted() {
		this.loadSettings()
	},
	methods: {
		loadSettings() {
			this.$store
				.dispatch('settings/get')
				.then(settings => {
					this.formData.weekly_point = settings.weekly_point
				})
				.catch(error => {
					this.$store.commit('app/SET_SNACKBAR_ERROR', error.response?.data?.message || 'Failed to load settings')
				})
		},
		updateSettings() {
			if (this.$refs.form.validate()) {
				this.isLoading = true
				this.$store
					.dispatch('settings/update', this.formData)
					.then(response => {
						this.isLoading = false
						this.$store.commit('app/SET_SNACKBAR_SUCCESS', response.data?.message || 'Settings updated successfully')
						this.loadSettings()
					})
					.catch(error => {
						this.isLoading = false
						const { errors } = error.response?.data || {}
						if (errors) {
							this.$set(this, 'errors', errors)
							this.$set(this, 'valid', false)
						}
						this.$store.commit('app/SET_SNACKBAR_ERROR', error.response?.data?.message || 'Failed to update settings')
					})
			}
		},
	},
}
</script>

<style scoped>
</style>
